import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetSubscriptionStatusUseCase } from './GetSubscriptionStatusUseCase';

export const initializeUserIdentityUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetSubscriptionStatusUseCase, {
        useClass: GetSubscriptionStatusUseCase,
    });
};
